var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "status-and-history" }, [
    _c(
      "div",
      {
        staticClass: "status-and-tariff-wrapper",
        class: {
          "status-and-tariff-wrapper--with-date":
            _vm.contractStatus == "service",
        },
      },
      [
        _c("div", { staticClass: "status" }, [
          _c("div", { staticClass: "status__prop" }, [
            _vm._v("Статус договора"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              class: [
                "status__value",
                `status__value--status--${_vm.contractStatus}`,
              ],
            },
            [_vm._v("\n        " + _vm._s(_vm.statusName) + "\n      ")]
          ),
        ]),
        _vm._v(" "),
        _vm.contractStatus == "service"
          ? _c("div", { staticClass: "date" }, [
              _c("div", { staticClass: "date__prop" }, [
                _vm._v("Дата заключения:"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "date__value" }, [
                _vm._v(_vm._s(_vm._f("localDate")(_vm.contractStartDate))),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "tariff" }, [
          _c("div", { staticClass: "tariff__prop" }, [_vm._v("Тариф")]),
          _vm._v(" "),
          _c("div", { staticClass: "tariff__value" }, [
            _vm._v(_vm._s(_vm.contractTariffName)),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "history", on: { click: _vm.toggleContractHistory } },
      [
        _c("img", {
          staticClass: "history__icon",
          attrs: { src: require("@icons/history.svg"), alt: "history.svg" },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "history__text" }, [
          _vm._v("История действий"),
        ]),
        _vm._v(" "),
        _c(
          "FadeTransaction",
          [
            _vm.contractHistoryIsOpen
              ? _c("ContractHistory", { staticClass: "history__box" })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }